import { useCallback } from 'react';
import { LinkProps, useRouter } from '@tanstack/react-router';

import { useAuth } from '@features/auth/hooks/useAuth';
import { createLoginLink } from '@features/auth/utils/redirect';
import { useClubCardQuery, useJoinClubMutation } from '@features/club/api/hooks';
import { ClubParticipationButton } from '@features/club/ui/ClubParticipationButton/ClubParticipationButton';

type Props = {
  clubId: string;
};
export function ClubParticipationButtonWidget({ clubId }: Props) {
  const router = useRouter();
  const {
    data: club,
    isPending: isClubPending,
    refetch,
  } = useClubCardQuery(clubId, { staleTime: Infinity });
  const { mutateAsync: joinClub, isPending: isJoinPending } = useJoinClubMutation(clubId);
  const { isAuthenticated } = useAuth();

  const onClubJoin = useCallback(async () => {
    if (isAuthenticated) {
      await joinClub();
      refetch();
    } else {
      const back = {
        to: '/club/$clubId',
        params: { clubId },
        from: '/',
      } satisfies LinkProps;

      window.location.href = createLoginLink(router.buildLocation(back).href);
    }
  }, [joinClub, refetch, isAuthenticated, clubId, router]);

  return (
    <ClubParticipationButton
      memberStatus={club?.memberStatus}
      onClubJoin={onClubJoin}
      isLoading={!club}
      disabled={isJoinPending || isClubPending}
    />
  );
}
